import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./routes/ProtectedRoute";

import Login from "./pages/login/Login";
import Menu from "./components/menu/menu";
import Products from "./pages/products/Products";
import CreateProduct from "./pages/create-product/CreateProduct";
import EditProduct from "./pages/edit-product/EditProduct";
import Messages from "./pages/messages/Messages";
import Catalog from "./pages/catalog/Catalog";
import Certifications from "./pages/certifications/Certifications";
import Account from "./pages/account/Account";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Menu />
              </ProtectedRoute>
            }
          >
            <Route index path="products" element={<Products />} />
            <Route path="create-product" element={<CreateProduct />} />
            <Route path="edit-product/:id" element={<EditProduct />} />
            <Route path="messages" element={<Messages />} />
            <Route path="catalog" element={<Catalog />} />
            <Route path="certifications" element={<Certifications />} />
            <Route path="account" element={<Account />} />
            <Route path="*" element={<Navigate to="/products" replace />} />
          </Route>
          <Route path="*" element={<Navigate to="/products" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;